const encodeSlash = (str) => {
	return str ? str.replace(/\//g, "@F0") : "";
};

export default encodeSlash;
